export const Header = ({ children }: any) => (
  <div className="focus-within:ring-secondary bg-primary border-primary mb-4 flex justify-between rounded-lg border px-3 py-2 focus-within:ring-1 focus-within:ring-inset md:mb-0 md:rounded-none md:rounded-t-lg md:border-0 md:px-6 md:py-3.5">
    {children}
  </div>
);
